import Excel from 'exceljs';
import * as FileSaver from 'file-saver';
import { SiMicrosoftexcel } from 'react-icons/si';
import Swal from 'sweetalert2';
import { apiPost } from '../../apis';
import { useMsal } from '@azure/msal-react';
import moment from 'moment';
import { Dropdown } from 'react-bootstrap';
import { orderStatusMappings } from '../../types/order';
import { formatDateTime } from '../../helpers/datetime';
import { setFullLoading } from '../../store/appSlice';
import { useDispatch } from 'react-redux';

export const ExportSaleOrders = (props) => {
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch()

  const prepareSheetOne = ({ workbook, exportData }) => {
    const sheet = workbook.addWorksheet('Header');

    const header = [
      'ORDERNUMBER',
      'CustAccount',
      'DeliveryName',
      'DeliveryStreet',
      'DeliveryCity',
      'DeliveryState',
      'DeliveryZIPCode',
      'DeliveryCountryRegionID',
      'PurchOrderFormNum',
      'SalesPoolId',
      'smmCampaignId',
      'Payment',
      'EndDisc',
      'CustomerRef',
    ];

    const excelData = exportData?.map((d) => {
      return {
        'ORDERNUMBER': d?.orderNumber,
        'CustAccount': d?.employeeId,
        'DeliveryName': '',
        'DeliveryStreet': '',
        'DeliveryCity': '',
        'DeliveryState': '',
        'DeliveryZIPCode': '',
        'DeliveryCountryRegionID': '',
        'PurchOrderFormNum': d?.orderNumber,
        'SalesPoolId': '',
        'smmCampaignId': '',
        'Payment': '',
        'EndDisc': '',
        'CustomerRef': '',
      };
    });

    sheet.addRow(header);
    for (const content of excelData) {
      sheet.addRow(Object.values(content));
    }

    sheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'cccccc' },
    };

    return workbook;
  };

  const prepareSheetTwo = ({ workbook, exportData }) => {
    const sheet = workbook.addWorksheet('Lines');

    const header = [
      'ORDERNUMBER',
      'InventSiteId',
      'ItemId',
      'SalesQty',
      'LineDisc',
      'Barcode',
      'InventLocationId',
      'SalesPrice',
      'LinePercent',
      'ShippingDateRequested',
      'SalesLineOCP.SalesLeadTimeInWeeks',
      'PurchOrderFormNum',
    ];

    const orderDetails = [];

    for (const d of exportData) {
      orderDetails.push(...d?.orderDetails);
    }

    const excelData = orderDetails?.map((d) => {
      return {
        'ORDERNUMBER': d?.orderNumber,
        'InventSiteId': '',
        'ItemId': d?.sku,
        'SalesQty': d?.qty || 0,
        'LineDisc': '',
        'Barcode': '',
        'InventLocationId': '',
        'SalesPrice': d?.price?.toLocaleString('en-US') || 0,
        'LinePercent': '',
        'ShippingDateRequested': moment(d?.createdAt).add(14, 'days').format('DD/MM/YYYY'),
        'SalesLineOCP.SalesLeadTimeInWeeks': 1,
        'PurchOrderFormNum': d?.orderNumber,
      };
    });

    sheet.addRow(header);
    for (const content of excelData) {
      sheet.addRow(Object.values(content));
    }

    sheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'cccccc' },
    };

    return workbook;
  };

  const exportExcel = () => {
    Swal.fire({
      title: 'Enter limit to export.',
      input: 'number',
      inputAttributes: {
        min: '1',
        autocapitalize: 'off',
      },
      inputValue: 1,
      confirmButtonText: 'Export',
      confirmButtonColor: 'green',
      showLoaderOnConfirm: true,
      didOpen: () => {
        const regExp = /^0[0-9].*$/;
        const input = Swal.getInput();
        input.oninput = (e) => {
          const limitInput = e.target.value;

          if (limitInput < 1 || regExp.test(limitInput)) {
            Swal.showValidationMessage(`Enter valid number!`);
          } else {
            Swal.resetValidationMessage();
          }
        };
      },
      inputValidator: (value) => {
        const regExp = /^0[0-9].*$/;

        if (value < 1 || regExp.test(value)) {
          return 'Enter valid number!';
        }
      },
      preConfirm: async (limit) => {
        try {
          let payload = props?.payloadForExcel || {};
          payload = {
            ...payload,
            limit: limit,
          };

          const json = await apiPost({
            uri: `Admin/order/list`,
            payload: payload,
            msal: {
              instance: instance,
              accounts: accounts,
            },
          });

          return json;
        } catch (error) {
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (!result?.isConfirmed) return;

      const workbook = new Excel.Workbook();

      prepareSheetOne({ workbook, exportData: result?.value?.orders || [] });
      prepareSheetTwo({ workbook, exportData: result?.value?.orders || [] });

      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        FileSaver.saveAs(blob, 'ax_sales_order.xlsx');
      });
    });
  };
  const getCreatedAtForStatusId = (order, statusId) => {
    const history = order.orderHistories.find(hist => hist.orderStatusId === statusId);
    return history ? history.createdAt : undefined;
  };
  const prepareOrderTemplateSheetOne = ({ workbook, exportData }) => {
    const sheet = workbook.addWorksheet('Orders');
    const header = [
      'Order Number',
      'Employee Id',
      'Site',
      'Qty',
      'Total',
      'Order Status',
      'Order Date',
      'Ready to Pickup',
      'Lead Time'
    ];
    const excelData = exportData?.map((d) => {
      let pickupDate = getCreatedAtForStatusId(d,3);
      let createdDate = moment(d?.createdAt);
      let readyToPickupDate = moment(pickupDate);
      console.log("Pick up date=>",pickupDate);
      return {
        'Order Number': d?.orderNumber || '',
        'Employee Id': d?.employeeId || '',
        'Site': d?.site || '',
        'Qty': d?.qty?.toLocaleString('en-US') || 0,
        'Total': d?.total?.toLocaleString('en-US') || 0,
        'Order Status': orderStatusMappings?.find((v) => v?.key == d?.orderStatusId)?.displayLabel?.th || '',
        'Order Date': formatDateTime({ dateTime: d?.createdAt, dateOnly: false, convertToThai: true }) || '',
        'Ready to Pickup': formatDateTime({ dateTime:getCreatedAtForStatusId(d,3), dateOnly: false, convertToThai: true }) || '',
        'Lead Time': (pickupDate)? readyToPickupDate.diff(createdDate,'days'):"",
      };
    });

    sheet.addRow(header);
    for (const content of excelData) {
      sheet.addRow(Object.values(content));
    }

    sheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'cccccc' },
    };

    for (let i = 0; i < excelData.length; i++) {
      const obj = excelData[i];
      const contentArr = Object.values(obj);
      const statusIndexInExcel = 5;
      const statusColor = orderStatusMappings?.find((v) => v?.displayLabel?.th == contentArr[statusIndexInExcel])?.color
      const contentRowIndex = i + 2;

      sheet.getRow(contentRowIndex).getCell(6).font = { color: { argb: statusColor ? statusColor.slice(1) : '' } };
    }

    return workbook
  }
  const prepareOrderTemplateSheetTwo = ({ workbook, exportData }) => {
    const orderDetails = [];

    for (const d of exportData) {
      const newDetails = d?.orderDetails?.map((obj) => {
        return {
          ...obj,
          employeeId: d?.employeeId,
          site: d?.site,
          orderStatusId: d?.orderStatusId
        }
      })

      console.log('newDetails', newDetails);

      orderDetails.push(...newDetails);
    }

    const sheet = workbook.addWorksheet('Order Details');
    const header = [
      'Order Number',
      'Employee Id',
      'Site',
      'SKU',
      'Item Name',
      'Qty',
      'Total',
      'Order Status',
      'Order Date',
    ];
    const excelData = orderDetails?.map((d) => {
      return {
        'Order Number': d?.orderNumber || '',
        'Employee Id': d?.employeeId || '',
        'Site': d?.site || '',
        'SKU': d?.sku || '',
        'Item Name': d?.productName || '',
        'Qty': d?.qty?.toLocaleString('en-US') || 0,
        'Total': d?.total?.toLocaleString('en-US') || 0,
        'Order Status': orderStatusMappings?.find((v) => v?.key == d?.orderStatusId)?.displayLabel?.th || '',
        'Order Date': formatDateTime({ dateTime: d?.createdAt, dateOnly: false, convertToThai: true }) || '',
      };
    });

    sheet.addRow(header);
    for (const content of excelData) {
      sheet.addRow(Object.values(content));
    }

    sheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'cccccc' },
    };

    for (let i = 0; i < excelData.length; i++) {
      const obj = excelData[i];
      const contentArr = Object.values(obj);
      const statusIndexInExcel = 7;
      const statusColor = orderStatusMappings?.find((v) => v?.displayLabel?.th == contentArr[statusIndexInExcel])?.color
      const contentRowIndex = i + 2;

      sheet.getRow(contentRowIndex).getCell(8).font = { color: { argb: statusColor ? statusColor.slice(1) : '' } };
    }

    return workbook
  }

  const exportOrderTemplate = async () => {
    try {
      dispatch(setFullLoading(true));

      const limit = 1000000;
      let payload = props?.payloadForExcel || {};
      payload = {
        ...payload,
        limit: limit,
      };
      const orderList = await apiPost({
        uri: `Admin/order/list`,
        payload: payload,
        msal: {
          instance: instance,
          accounts: accounts,
        },
      });
      const workbook = new Excel.Workbook();

      prepareOrderTemplateSheetOne({ workbook, exportData: orderList?.orders || [] });
      prepareOrderTemplateSheetTwo({ workbook, exportData: orderList?.orders || [] });

      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        FileSaver.saveAs(blob, 'sales_order.xlsx');
      });

      dispatch(setFullLoading(false));
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className='w-100 d-flex justify-content-end'>
      <Dropdown className=''>
        <Dropdown.Toggle className='admin-export-excel-dropdown-btn'>
          <SiMicrosoftexcel size={'20px'} className='me-2' />Export
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item>
            <div onClick={exportOrderTemplate}>
              Order Template
            </div>
          </Dropdown.Item>
          <Dropdown.Item>
            <div onClick={exportExcel}>
              AX Template
            </div>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
